module.exports = __webpack_public_path__ + "static/img/espacioscomerciales.f0b286c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/proyectos_comerciales_secciones/espacioscomerciales.jpg
// module id = cNUT
// module chunks = 1